<template>
  <div
    class="esri-home esri-widget--button esri-widget"
    role="button"
    tabindex="{0}"
    aria-label="Default map view"
    title="Default map view"
    @click="goHome()"
  >
    <span aria-hidden="true" class="esri-icon esri-icon-home"></span>
    <span class="esri-icon-font-fallback-text">Home</span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import appConfig from '../config/appConfig';

// TODO Not clear why I have to re-import store here, but it appears it is not
// available via this.$store like normal. Perhaps because I add this component
// programmatically rather than the standard Vue way?
import store from '../store';

export default {
  id: 'MapHomeButton',
  methods: {
    goHome: function () {
      store.dispatch('mapTemplate/selectItem', {
        value: appConfig.countriesApiProps.globalCountryValue,
        type: 'Country'
      });
    }
  }
};
</script>

<style scoped></style>
